import { Theme } from '@mui/material/styles'

import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    display: 'block',
  },
  paperContainer: {
    margin: theme.spacing(4, 5),
    flexDirection: 'column',
    textAlign: 'initial',
    marginBottom: '130px',
  },
  labraAiAwsBadge: {
    margin: theme.spacing(0, 5, 2, 5),
  },
  formControl: {
    margin: theme.spacing(1),
    ['@media (min-width:1230px)']: {
      minWidth: 250,
    },
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  radioButtoms: {
    display: 'block',
  },
  radioGroup: {
    display: 'flex',
  },
  groupTitle: {
    paddingTop: '16px',
    paddingRight: '10px',
  },
  terms: {
    height: '300px',
    overflow: 'auto',
  },
  divider1: {
    margin: theme.spacing(2.375, 0, 4.5, 0),
    backgroundColor: theme.palette.bg.main,
    height: '2px',
  },
  subtitle: {
    marginTop: theme.spacing(4.5),
  },
  divider2: {
    margin: theme.spacing(4.02, 0, 3.9375, 0),
    height: '2px',
  },
  divider3: {
    margin: theme.spacing(1.125, 0, 3.3125, 0),
    height: '2px',
  },
  checkbox: {
    paddingLeft: '0px',
  },
  paragraph: {
    paddingTop: theme.spacing(2.8025),
    margin: theme.spacing(0, 0, 0, 0),
    color: theme.palette.black.main,
    fontSize: '14px',
  },
  gridRoot: {
    paddingTop: theme.spacing(2),
    marginTop: theme.spacing(0),
  },
  select: {
    fontSize: '13px',
    '& .MuiMenuItem-root': {
      fontSize: '13px',
    },
  },
  label: {
    fontSize: '13px',
  },
  termsSubHeading: {
    fontSize: '14px',
    fontWeight: 500,
    color: theme.palette.black.main,
  },
  termsParagraph: {
    fontSize: '14px',
    color: theme.palette.black.main,
  },
  AcceptButtom: {
    backgroundColor: theme.palette.opaque.dark,
    width: '184px',
    height: '40.6px',
    color: 'white',
    '&:hover': {
      backgroundColor: theme.palette.opaque.main,
    },
    '&.Mui-disabled': {
      color: theme.palette.primary.light,
      backgroundColor: theme.palette.opaque.light,
      fontWeight: 500,
    },
    borderRadius: theme.spacing(0.5),
    fontFamily: theme.typography.fontFamily,
    fontWeight: 500,
    textTransform: 'capitalize',
    marginRight: 15,
    float: 'right',
  },
  DeclinetButtom: {
    width: '100px',
    height: '40.6px',
    borderRadius: theme.spacing(0.5),
    fontFamily: theme.typography.fontFamily,
    fontWeight: 500,
    textTransform: 'capitalize',
    padding: 5,
    display: 'none',
  },
  title: {
    fontWeight: 600,
  },
  CheckBoxNotVisible: {
    display: 'none',
  },
  CheckBoxVisible: {
    display: 'block',
  },

  section: {
    margin: theme.spacing(4, 0),
  },
  url: {
    color: theme.palette.select.light,
    fontFamily: theme.typography.fontFamily,
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '20px',
    letterSpacing: '0.1px',
    textDecoration: 'none',
  },
  descripAndUrl: {
    marginLeft: theme.spacing(4.3),
    marginTop: '-10px',
  },
  checkBoxDescription: {
    marginLeft: theme.spacing(4.3),
  },
  checkBoxDescriptionText: {
    color: theme.palette.labraText.description,
    fontFamily: theme.typography.fontFamily,
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
  },
  inputTitle: {
    color: theme.palette.textField.dark,
    fontFamily: theme.typography.fontFamily,
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '24px',
    letterSpacing: '0.5px',
  },
  termsAndConditions: {
    marginTop: theme.spacing(0.25),
    color: theme.palette.labraText.description,
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
  },
  actionsButton: {
    paddingLeft: theme.spacing(2),
  },
  checkboxContainer: {
    display: 'flex',
    width: '100%',
    gap: theme.spacing(3),
  },
  box: {
    border: '1px solid',
    borderRadius: '4px',
    padding: theme.spacing(3),
    width: '100%',
    borderColor: theme.palette.dividerV2.main,
  },
  checkboxLabel: {
    fontFamily: 'Poppins',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '24px',
    letterSpacing: '0.5px',
    color: theme.palette.labraText.primary,
  },
  checkboxSupportText: {
    fontFamily: 'Poppins',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
    color: theme.palette.labraText.secondaryDescription,
  },
  subHeading: {
    fontStyle: theme.typography.fontFamily,
    fontSize: '14px',
    color: theme.palette.labraText.description,
    fontWeight: 500,
    lineHeight: '20px',
    letterSpacing: '0.25px',
    marginTop: theme.spacing(1),
  },
  heading: {
    fontFamily: theme.typography.fontFamily,
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '24px',
    letterSpacing: '0.15px',
  },
  headingContainer: {
    marginBottom: theme.spacing(-2),
  },
  modalRoot: {
    maxWidth: '420px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '16px',
    textAlign: 'center',
    paddingBottom: theme.spacing(2),
    color: theme.palette.labraText.description,
  },
  modalHeader: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 400,
    fontSize: '22px',
    lineHeight: '28px',
    paddingBottom: theme.spacing(2),
  },
  modalBottomInfo: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 500,
    fontSize: '12px',
    lineHeight: '16px',
    textAlign: 'center',
    color: theme.palette.labraText.description,
  },
  disableImage: {
    width: '90%',
    height: '100%',
    maxHeight: '204px',
    maxWidth: '224px',
  },
  imgRoot: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingBottom: theme.spacing(1.2),
  },
  button: {
    paddingTop: theme.spacing(3),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  footerCustomClass: {
    padding: `${theme.spacing(1.5, 5)} !important`,
  },
  checkTermsAndConditions: {
    marginBottom: theme.spacing(-1.625),
  },
  errorMessage: {
    color: theme.palette.error.dark,
    fontSize: '12px',
    marginTop: theme.spacing(1),
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '16px',
  },
}))
